import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import './Rblog.css';
import BlogCard from '../Blogcard/BlogCard';
import { useBlogs } from '../../Context/BlogContext';
import { Link } from 'react-router-dom';

const Rblog = () => {
    // Destructure the data from useBlogs hook
    const { blogs, loading, error } = useBlogs(); // Assuming this returns { blogs, loading, error }
    const numberOfItems = Math.min(blogs.length, 9); // Limit to 9 items

    if (loading) {
        return <p>Loading blogs...</p>; // Show a loading message
    }

    if (error) {
        return <p>{error}</p>; // Show any error messages
    }

    return (
        <div id='Rblog'>
            <div className='Rblog'>
                <div className='Rblog-head' >
                    <Link to="/blog"> &lt; عرض المزيد</Link>
                    <h5>احدث المقالات</h5>
                </div>
                <div className='Rblog-container'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1}
                        scrollbar={{ draggable: true }} // Enable draggable scrollbar
                        modules={[Scrollbar]} // Import necessary modules
                        breakpoints={{
                            768: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                            1366: {
                                slidesPerView: 4,
                            },
                            1600: {
                                slidesPerView: 5,
                            },
                        }}
                    >
                        {blogs.length > 0 ? (
                            blogs.slice(0, numberOfItems).map((blog) => (
                                <SwiperSlide key={blog.id}>
                                    <BlogCard
                                        id={blog.id}
                                        Pimg={blog.image}
                                        title={blog.title}
                                        content={blog.content}
                                        date={blog.createdAt ? new Date(blog.createdAt).toLocaleDateString() : 'Unknown date'}
                                    />
                                </SwiperSlide>
                            ))
                        ) : (
                            <p>لا يوجد مدونات</p> // Message for no blogs
                        )}
                        <br />
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default Rblog;
